/*eslint-disable*/
import Vue from 'vue';
import Router from 'vue-router';
import HOME from '../views/HOME';
import $Cookies from 'js-cookie'
import $qs from 'qs';
// import { MessageBox } from 'element-ui';
import { Notification } from 'element-ui';
import i18n from "../i18n/i18n";
import { store } from '@/common/index';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base:'/',
  routes: [
    {path: '/', meta: { navShow: true,keepAlive: false, homeSidebar:true },redirect:'/home', name: 'HOME', component: HOME,},
    {path: '/home', meta: { navShow: true,keepAlive: false, homeSidebar:true }, name: 'HOME1', component: HOME,},
    {path: '/chess',meta: { navShow: true }, name: 'liveCasino', component: ()=> import('../views/game/chess/chess') },
    {path: '/slots',meta: { navShow: true }, name: 'slots', component: ()=> import('../views/game/slots/slot-page') },
    {path: '/fish',meta: { navShow: true }, name: 'fish', component: ()=> import('../views/game/fish/fish') },
    
    
    { 
      path: '/register',
      meta: { navShow: true }, 
      name: 'register',
      component: ()=> import('../components/register/')
    },
    {
      path: '/newregister',
      meta: {
        navShow: true,
        titleHide: true
      },
      name: 'newRegister',
      component: ()=> import('../components/newregister/')
    },
    {
      path: '/sports',
      meta: { navShow: true }, 
      name: 'sports', 
      component: ()=> import('../views/game/sports/sports') 
    },

    {  // games 中包含 真人 电子 彩票等内容 ，且 嵌套 slot 内页 和 彩票 内页
      path: '/games',
      meta: { navShow: true }, 
      name: 'games', 
      component: ()=> import('../views/game/games') 
    },
    
    {
      path: '/team',
      meta: { navShow: true,requireAuth:true }, 
      name: 'team',
      redirect: '/team/mypromoition',
      component: ()=> import('../views/team'),
      children:[
        {
          path:'mypromoition',
          meta: { navShow: true,requireAuth:true },
          name: '/team/mypromoition', 
          component: ()=> import('../views/team/M_promotion')
        },
        {
          path:'Performance',
          meta: { navShow: true,requireAuth:true },
          name: '/team/performance', 
          component: ()=> import('../views/team/P_inquiry') 
        },
        {
          path:'Player',
          meta: { navShow: true,requireAuth:true },
          name: '/team/player', 
          component: ()=> import('../views/team/P_player') 
        },
        {
          path:'myteam',
          meta: { navShow: true,requireAuth:true },
          name: '/team/myteam', 
          component: ()=> import('../views/team/T_team') 
        },
        {
          path:'friend',
          meta: { navShow: true,requireAuth:true },
          name: '/team/friend', 
          component: ()=> import('../views/team/I_friends') 
        },
      ]
    },


    {path: '/hotGame',meta: { navShow: true }, name: 'hotGame', component: ()=> import('../views/game/hotGame') },
    {path: '/lottery',meta: { navShow: true }, name: 'lottery', component: ()=> import('../views/game/lottery/lottery') },
    // {path: '/live',meta: { navShow: true }, name: 'live', component: ()=> import('../views/game/live/live') },
    // {path: '/deposit',meta: { navShow: false, requireAuth:true }, name: 'deposit-page', component: ()=> import('../views/deposit/deposit-page') },
    {path: '/download', meta: { navShow: false }, name: 'download', component: ()=> import('../views/download/download'),},
    {path: '/wheel',meta: { navShow: true }, name: 'wheel', component: ()=> import('../views/wheel/wheel') },
    {path: '/privilege',meta: { navShow: true }, name: 'privilege', component: ()=> import('../views/mine/minePage/privilege') },
    {
      path: '/agency',
      meta: { navShow: true }, 
      name: 'agency', component: ()=> import('../views/agency/agency') 
    },
    {path: '/discountsHall',meta: { navShow: true }, name: 'discountsHall', component: ()=> import('../views/discounts/discountsHall') },
    // {
    //   path: '/ColorLight',
    //   meta: { navShow: true }, 
    //   name: 'ColorLight', 
    //   component: ()=> import('../views/colorlight/colorlight') 
    // },
    {
      path: '/discounts',
      redirect: '/discounts/all',
      meta: { navShow: true }, 
      name: 'discounts', 
      component: ()=> import('../views/discounts/discounts'),
      children:[
        {
          path: 'all',
          meta: { navShow: true }, 
          name: 'all', 
          component: ()=> import('../views/discounts/discountPage/all') 
        },
      ]
    },
    {
      path: '/discounts/discountsDetail',
      meta: { navShow: true, asideHide:true  }, name: 'discounts', 
      component: ()=> import('../views/discounts/discountPage/all'),
    },
    {
      path: '/mine',
      redirect: '/mine/deposit', 
      meta: { navShow: true,requireAuth:true }, 
      name: 'mine', 
      component: ()=> import('../views/mine/mine'),
      children: [
          // 余额宝
          // {path: 'yuebao',meta: { navShow: true,requireAuth:true }, name: '/mine/yuebao', component: ()=> import('../views/mine/yuebao/yuebao') },
        {path: 'myCollect',meta: { navShow: true,requireAuth:true }, name: '/mine/myCollect', component: ()=> import('../views/mine/minePage/myCollect') },
        {path: 'center',meta: { navShow: true,requireAuth:true }, name: '/mine/center', component: ()=> import('../views/mine/minePage/center') },

        {
          path: 'invitation',
          meta: { navShow: true,requireAuth:true }, 
          name: '/mine/invitation', 
          component: ()=> import('../views/mine/minePage/invitation') 
        },
        {
          path: 'billDetail',
          meta: { navShow: true,requireAuth:true }, 
          name: '/mine/billDetail', 
          component: ()=> import('../views/mine/minePage/billDetail') 
        },
        {
          path: 'safety',
          meta: { navShow: true,requireAuth:true }, 
          name: '/mine/safety', 
          component: ()=> import('../views/mine/minePage/safety') 
        },
        // {path: 'myDiscounts',meta: { navShow: true,requireAuth:true }, name: '/mine/myDiscounts', component: ()=> import('../views/mine/minePage/myDiscounts') },
        {
          path: 'inEmail',
          meta: { navShow: true,requireAuth:true }, 
          name: '/mine/inEmail', 
          component: ()=> import('../views/mine/inEmail/inEmail') 
        },
        {
          path: 'betList',
          meta: { navShow: true,requireAuth:true }, 
          name: '/mine/betList',
          redirect: '/mine/betList/cricket-record',
          component: ()=> import('../views/mine/betList/index.vue'),
          children:[
            {
              path: 'cricket-record',
              meta: { navShow: true,requireAuth:true }, 
              name: '/mine/betList/cricket-record', 
              component: ()=> import('../views/mine/betList/cricket-record.vue') 
            },
            {
              path: 'other-record',
              meta: { navShow: true,requireAuth:true }, 
              name: '/mine/betList/other-record', 
              component: ()=> import('../views/mine/betList/other-record.vue') 
            },
          ]
        },

        // {path: 'getBonus',meta: { navShow: true,requireAuth:true }, name: '/mine/getBonus', component: ()=> import('../views/mine/minePage/getBonus') },
        // {path: 'capital',redirect: '/mine/capital/account',meta: { navShow: true,requireAuth:true }, name: '/mine/capital', component: ()=> import('../views/mine/minePage/capital'),
          // children:[
        {path: 'account',meta: { navShow: true,requireAuth:true }, name: '/mine/account', component: ()=> import('../views/mine/minePage/capital/account') },
        
        
        {
          path: 'deposit',
          meta: { navShow: true,requireAuth:true }, 
          name: '/mine/deposit', 
          component: ()=> import('../views/mine/minePage/capital/deposit') 
        },
        {
          path: 'latestDeposit',
          meta: { navShow: true,requireAuth:true }, 
          name: '/mine/latestDeposit', 
          component: ()=> import('../views/mine/minePage/capital/latestDeposit/index.vue') 
        },
        {
          path: 'withdrawal',
          meta: { navShow: true,requireAuth:true }, 
          name: '/mine/withdrawal', 
          component: ()=> import('../views/mine/minePage/capital/withdrawal') 
        },
        {
          path: 'bankList',
          meta: { navShow: true,requireAuth:true }, 
          name: '/mine/bankList', 
          component: ()=> import('../views/mine/minePage/capital/bankList') 
        },
        {
          path: 'withdrawalList',
          meta: { navShow: true,requireAuth:true }, 
          name: '/mine/withdrawalList', 
          component: ()=> import('../views/mine/minePage/capital/withdrawalList') 
        },
        {
          path: 'lockAmount',
          meta: { navShow: true,requireAuth:true }, 
          name: '/mine/lockAmount', 
          component: ()=> import('../views/mine/minePage/capital/lockAmount') 
        },
          // ]
        // },
        {
          path: 'task',
          meta: { navShow: true,requireAuth:true }, 
          name: '/mine/task',
          component: ()=> import('../views/mine/task/index.vue'),
        },


        {path: 'backwater', redirect: '/mine/backwater/details', meta: { navShow: true,requireAuth:true }, name: '/mine/backwater', component: ()=> import('../views/mine/minePage/backwater/backwater'),
          children:[
            {path: 'details',meta: { navShow: true,requireAuth:true }, name: '/mine/backwater/details', component: ()=> import('../views/mine/minePage/backwater/details') },
            {path: 'receive',meta: { navShow: true,requireAuth:true }, name: '/mine/backwater/receive', component: ()=> import('../views/mine/minePage/backwater/receive') },
          ]
        },
      ]
    },




    {
      path: '/helpCenter', 
      redirect: '/helpCenter/startUse', 
      meta: { navShow: true }, 
      name: 'helpCenter', 
      component: ()=> import('../views/helpCenter/helpCenter'),
      children: [
        {
          path: 'startUse',
          meta: { navShow: true}, 
          name: '/helpCenter/startUse', 
          component: ()=> import('../views/helpCenter/pages/startUse') },
      ]
    },

    { path: '/404',meta: { navShow: false,asideHide:true },name:'404',component: ()=> import('../views/notfound/404')},
    { path: '*',meta: { navShow: false,asideHide:true},name:'notfound',component: ()=> import('../views/notfound/404')},
  ],
});

function Message() {
  // MessageBox('请先登录', '温馨提示', {
  //   confirmButtonText: '确定',
  // });
  Notification.error({
      title: i18n.t('notify.error'),
      message: i18n.t('newHome.login'),
  });


}

function setAgentCode() { // 存入代理注册code并修改网页路径
  const hrefStr = window.location.href
  if (hrefStr.indexOf('?agentCode=') !== -1) {
    const agentCode = hrefStr.split('?agentCode=')[1].split('/')[0]
    $Cookies.set('agentCode', agentCode, { expires: 1 })
    if(hrefStr.indexOf('/newregister') !== -1){
      window.location.href = window.location.origin + '/newregister'
    }else{
      window.location.href = window.location.origin + '/register'
    }
    // console.log(agentCode,'123',window.location)
    if (hrefStr.indexOf('/register') === -1) { // 不是邀请链接的时候
      const str = '?agentCode=' + agentCode
      if (!!(window.history && history.pushState)) {
        history.replaceState(null, null, (window.location.href.replace(str, '') + str))
      } else {
        window.location.href = window.location.href.replace(str, '') + str
      }
    }
  }
}

function checkLogin() {  // 判断本地是否存在UUID 

  let url = window.location.href;
  let UUID = $qs.parse(url.split('?')[1]).UUID;
  if (UUID === undefined) {
    UUID = $Cookies.get('UUID')
  } else {
    $Cookies.set('UUID', UUID)
  }
  if(UUID) {
    let obj ={};
    obj['isLogin'] = true;
    obj['UUID'] = UUID;
    store.commit('CHECK_LOGIN', obj)
  }else {
    store.commit('LOGIN_OUT')
  }

}

router.beforeEach(function (to, from, next) {
  setAgentCode()
  checkLogin()
  if(to.matched.some(r => r.meta.requireAuth )){
    if(store.state.isLogin){
      next();
    }else {
      if($Cookies.get('UUID')){
        next();
      }else {
        Message();
        next({
          path: '/home',
          query: {redirect: to.fullPath}
        })
      }
    }
  } else {
    next();
  }
});

router.afterEach(function (to) {
  let fullPath = to.fullPath;
  if(fullPath.indexOf('/home') > -1) {
    // 是否在首页
    store.dispatch('JIN_SHA_GLOBAL_LOGIN', true);
    document.title = '1CRIC-Best Cricket Betting App in India';
  }else {
    store.dispatch('JIN_SHA_GLOBAL_LOGIN', false);
    let path = window.location.pathname;
    document.title = to.path.substr(1) + '-Best Cricket Betting App in India';

  }

})

export default router



// WEBPACK FOOTER //
// ./src/pages/build901/router/index.js